<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.warehousemanagement') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <WmsWarehouseForm
        :warehouses="warehouses"
        :products="products"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <BaseModalOverLimit
        :id="modalOverLimitId"
        :headerText="$t('overlimit.warehouse.header')"
        :bodyTextUnitPrice="$t('overlimit.warehouse.body.unitprice', { number: getCurrencyWithNumber(numberel(pricing.warehouse, '0,0')) })"
        :bodyTextPerMonth="$t('overlimit.warehouse.body.permonth')"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      modalOverLimitId: 'modalOverLimitId',
      form: null,
    }
  },

  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      warehouses: 'getWarehouses',
      products: 'getProducts',
    }),
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
  },

  watch: {
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 8,
        submenuAtIdx: 1,
      })
    },
  },

  async mounted () {
    await this.fetchData()
    this.formOriginal = cloneDeep(this.form)
    const isAvailableToCreate = this.$store.state.shop.availableToCreate.warehouse
    if (!isAvailableToCreate) {
      $(`#${this.modalOverLimitId}`).modal('show')
    }
  },

  beforeMount: function () {
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 9,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 8,
      submenuAtIdx: 1,
    })
  },

  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },

  methods: {
    ...mapActions([
      'getShopUseLimit',
      'getShopAvailableToCreate',
    ]),
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getProducts'),
        this.$store.dispatch('getWarehouses'),
        this.getShopUseLimit(),
        this.getShopAvailableToCreate({ type: 'warehouse' }),
        this.getPricing(),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getFormCreate (form = {}) {
      return {
        'warehouse_name': form.name,
        'short_name': form.nameShort.toUpperCase(),
        'address': form.address,
        'primary': form.primary,
      }
    },
    getFormAssign (form = {}) {
      return {
        'skus': form.assignSkus.map((item) => {
          return {
            'sku_id': item.value,
            'is_use_lot': item.useLot,
            'is_use_serial_number': item.useSerialNumber,
          }
        }),
      }
    },
    getFormInsertBins (form = {}) {
      return {
        'bins': form.binLocations.map((bin) => {
          return {
            'code': bin.code,
          }
        }),
      }
    },
    async handleSubmit (form = {}) {
      this.isSubmitted = true
      this.disabled = true
      const formCreate = this.getFormCreate(form)
      const formAssign = this.getFormAssign(form)
      const formInsertBins = this.getFormInsertBins(form)
      const responseCreate = await this.$store.dispatch('insertWarehouse', formCreate)
      if (form.binLocations.length) {
        const responseInsertBins = await this.$store.dispatch('insertWarehouseBins', { id: responseCreate.data.warehouse_id, data: formInsertBins })
      }
      const responseAssignSkus = await this.$store.dispatch('updateWarehouseAssignSkus', { id: responseCreate.data.warehouse_id, data: formAssign })
      if (responseCreate.success && responseAssignSkus.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({ name: 'WarehouseList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/warehouse/Create.vue